/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lifecycle_UnarchiveInputs */

const en_lifecycle_unarchive = /** @type {(inputs: Lifecycle_UnarchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unarchive`)
};

const de_lifecycle_unarchive = /** @type {(inputs: Lifecycle_UnarchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus dem Archiv holen`)
};

/**
* | output |
* | --- |
* | "Unarchive" |
*
* @param {Lifecycle_UnarchiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_unarchive = /** @type {((inputs?: Lifecycle_UnarchiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_UnarchiveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_unarchive(inputs)
	return en_lifecycle_unarchive(inputs)
});